import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import autoprefixer from 'material-ui/utils/autoprefixer';
import withWidth from 'material-ui/utils/withWidth';
import compose from 'recompose/compose';
import injectTapEventPlugin from 'react-tap-event-plugin';

import AdminRoutes from 'AdminRoutes';
import AppBar from './AppBar';
import Sidebar from './Sidebar';
import Menu from './Menu'
import Notification from './Notification';
import defaultTheme from '../defaultTheme';
import CircularProgress from './CircularProgress';


injectTapEventPlugin();

const styles = {
    wrapper: {
        // Avoid IE bug with Flexbox, see #467
        display: 'flex',
        flexDirection: 'column',
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    body: {
        backgroundColor: '#edecec',
        display: 'flex',
        flex: 1,
        overflowY: 'hidden',
        overflowX: 'scroll',
    },
    bodySmall: {
        backgroundColor: '#fff',
    },
    content: {
        flex: 1,
        padding: '2em',
    },
    contentSmall: {
        flex: 1,
        paddingTop: '3em',
    },
};

const prefixedStyles = {};

class Layout extends Component {

    render() {
        const {
            authClient,
            customRoutes,
            resources,
            theme,
            width,
            Logout,
            dashboard,
        } = this.props;
        const muiTheme = getMuiTheme(theme);
        const title = 'Ocha Admin';

        if (!prefixedStyles.main) {
            // do this once because user agent never changes
            const prefix = autoprefixer(muiTheme);
            prefixedStyles.wrapper = prefix(styles.wrapper);
            prefixedStyles.main = prefix(styles.main);
            prefixedStyles.body = prefix(styles.body);
            prefixedStyles.bodySmall = prefix(styles.bodySmall);
            prefixedStyles.content = prefix(styles.content);
            prefixedStyles.contentSmall = prefix(styles.contentSmall);
        }
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div style={prefixedStyles.wrapper}>
                    <div style={prefixedStyles.main}>
                        { width !== 1 && <AppBar title={title} />}
                        <div className="body" style={width === 1 ? prefixedStyles.bodySmall : prefixedStyles.body}>
                            <div style={width === 1 ? prefixedStyles.contentSmall : prefixedStyles.content}>
                                <AdminRoutes
                                    authClient={authClient}
                                    customRoutes={customRoutes}
                                    resources={resources}
                                    dashboard={dashboard}
                                />
                            </div>
                            <Sidebar theme={theme}>
                                <Menu resources={resources} customRoutes={customRoutes} title={title} logout={<Logout />}/>
                            </Sidebar>
                        </div>
                        <Notification />
                        <CircularProgress isLoading={false} />
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

Layout.propTypes = {
    authClient: PropTypes.func,
    customRoutes: PropTypes.array,
    resources: PropTypes.array,
    theme: PropTypes.object,
    width: PropTypes.number,
    Logout: PropTypes.func.isRequired,
    dashboard: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

Layout.defaultProps = {
    theme: defaultTheme,
};


const enhance = compose(
    withWidth(),
);

export default enhance(Layout);



// WEBPACK FOOTER //
// ./src/components/layout/Layout.js